import React from 'react';
import {
	Space, Card, Spin, Tabs, message, Timeline
} from 'antd';
import { CalendarOutlined } from '@ant-design/icons';
import { APIService } from '../../../services/projectManager/api';
import 'antd/dist/antd.css';
import './ShowRecord.scss';
import moment from 'moment';
import 'moment/locale/zh-cn';
import locale from 'antd/es/date-picker/locale/zh_CN';

class ShowRecord extends React.Component{
	
	constructor(props) {
		super(props);

		this.state = {
			data: [],
			loading: false,
		};
	}

	componentDidMount() {
		const { record_id } = this.props;
		this.getRecord(record_id);
	};

	getRecord = (record_id) => {
		this.setState((prev, props) => {
			return { loading:true }
		})
		let param = {
			record_id: record_id
		}
		APIService.GetRecordTips(param).then(res => {
			if(res.success){
				
			}else{
				console.log(`获取审批记录失败: ${res.error}`)
			}
			this.setState((prev, props) => {
				return { loading:false, data: res.data }
			})
		}).catch(err => {
			console.log('获取审批记录Error', err)
			this.setState((prev, props) => {
				return { loading:false }
			})
		})
	};

	getColor = (status) => {
		let color = 'gray';
		switch(status){
			case '通过':
				color = 'green';
				break;
			case '驳回':
				color = 'red';
				break;
			case '发起工作':
				color = 'blue';
				break;
			default:
				color = 'gray';
		}
		return color;
	};

	render(){
		const { data } = this.state;
		return(
			<div className="record-panel">
				<Card
					title="审批记录"
					style={{width: '100%'}}
				>
					<Timeline 
					>
						{
							data.map(row => (
								<Timeline.Item
									// label={row['handler_time']}
									key={row['handler_id']}
									dot={<CalendarOutlined style={{ fontSize: '20px' }} />}
									color={this.getColor(row['approve_result'])}
								>
									<div className="record-panel_info">
										<div className="record-panel_info-time">{row['handler_time']}</div>
										<div className="record-panel_info-user">{row['handler_name']}</div>
										<div className="record-panel_info-result">{row['approve_result']}</div>
										<div className="record-panel_info-commont">{row['comment']}</div>
									</div>
								</Timeline.Item>
							))
						}
					</Timeline>
				</Card>
			</div>
		)
	}
}

export default ShowRecord;


// WEBPACK FOOTER //
// app/components/customPage/showRecord/ShowRecord.jsx